export const SET_PROCESS = 'SET_PROCESS';
export const SET_PROCESS_NUMBER = 'SET_PROCESS_NUMBER';
